import React, { memo } from "react";
import useProfileSection from "./index.hooks";
import { AppButton, AppPaper, DefaultEvent, ProfileDetail } from "components";
import { CircularProgress, Grid, Tooltip, Typography } from "@material-ui/core";
import cn from "classnames";

type ProfileSectionProps = {};

const ProfileSection = ({}: ProfileSectionProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    posterUri,
    handleRegeneratePoster,
    isRegeneratingPoster,
  } = useProfileSection();

  return (
    <>
      <AppPaper className={styles.paperDetail}>
        <Grid alignItems="stretch" className={styles.gridItem}>
          <Typography variant="h4" color="primary" className={styles.inline}>
            Profilo
          </Typography>
        </Grid>
        <Grid
          container
          direction="row"
          alignItems="stretch"
          className={styles.gridContainer}
          spacing={1}
        >
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <ProfileDetail />
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <DefaultEvent />
          </Grid>
        </Grid>
      </AppPaper>
      <AppPaper className={cn(styles.paperDetail, atomicStyles.MT20)}>
        <Grid alignItems="stretch" className={styles.gridItem}>
          <Typography variant="h4" color="primary" className={styles.inline}>
            Locandina
          </Typography>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {isRegeneratingPoster ? (
              <CircularProgress />
            ) : (
              <img className={styles.poster} alt="locandina" src={posterUri} />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            className={cn(atomicStyles.MT20, atomicStyles.TAR)}
          >
            <AppButton
              className={atomicStyles.MR20}
              variant="contained"
              color="secondary"
              onClick={handleRegeneratePoster}
              disabled={isRegeneratingPoster}
            >
              Rigenera locandina
            </AppButton>
            <AppButton
              href={posterUri}
              variant="contained"
              color="primary"
              disabled={isRegeneratingPoster}
            >
              Stampa locandina
            </AppButton>
          </Grid>
        </Grid>
      </AppPaper>
    </>
  );
};

export default memo(ProfileSection);
